import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const STEPS = [
  {
    no: "01",
    title: "Send your trip details",
    copy: "Share your route or hotel, your dates, and the price you're getting. Takes less than a minute."
  },
  {
    no: "02",
    title: "We find a better price",
    copy: "Our travel expert checks fares, rates and deals you won't see on booking apps."
  },
  {
    no: "03",
    title: "You book and save",
    copy: "We send the better price on WhatsApp. You book it and keep the savings."
  }
];

const HowItWorks = () => (
  <section id="how" className="border-y border-ink/10 bg-ivory2 py-20 lg:py-32" data-testid="how-it-works">
    <div className="container-edit">
      <motion.p
        className="eyebrow mb-5 flex items-center gap-4"
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7, ease: EASE }}
      >
        <span className="inline-block h-px w-10 bg-cyan" /> How it works
      </motion.p>
      <motion.h2
        className="mb-16 max-w-2xl font-serif text-3xl font-medium leading-tight tracking-tight text-ink sm:text-4xl"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
      >
        Simple 3 steps to a <em className="italic text-ocean">better price.</em>
      </motion.h2>

      <div className="grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-8">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.no}
            className="border-t-2 border-ink/80 pt-6"
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.85, delay: i * 0.12, ease: EASE }}
            data-testid={`how-step-${s.no}`}
          >
            <span className="text-base font-bold text-cyan-deep">{s.no}</span>
            <h3 className="mt-3 font-serif text-2xl font-medium text-ink">{s.title}</h3>
            <p className="mt-3 max-w-sm text-[15px] leading-relaxed text-ink2">{s.copy}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
